import { lowerFirst } from "lodash-es";

import { LEVEL_BEGINNER, LEVEL_EXPERT, WEIGHTED_LEVELS } from "@/common/level-types";

/**
 * Maps Danish and Latin grammatical labels to their level-appropriate strings
 * @param {"beginner"|"intermediate"|"expert"} level
 * @param {string} danish
 * @param {string} latin
 * @param {string} glue String to join Danish and Latin labels on intermediate level
 * @returns {string}
 */
export const mapGrammaticalLabelsToLevel = (level, danish, latin, glue = " ") => {
  if (shouldShowDanish(level) && shouldShowLatin(level)) {
    return `${danish}${glue}(${lowerFirst(latin)})`;
  }

  if (shouldShowLatin(level)) {
    return latin;
  }

  return danish;
};

/**
 * @param {"beginner"|"intermediate"|"expert"} level
 * @returns {boolean}
 */
export const shouldShowDanish = (level) => WEIGHTED_LEVELS[level] < WEIGHTED_LEVELS[LEVEL_EXPERT];

/**
 * @param {"beginner"|"intermediate"|"expert"} level
 * @returns {boolean}
 */
export const shouldShowLatin = (level) => WEIGHTED_LEVELS[level] > WEIGHTED_LEVELS[LEVEL_BEGINNER];
